import { z } from 'zod'
import {
  sanitizeAdmindeskHandoffNext,
  sanitizeHandoffNext,
  sanitizeSuporteHandoffNext,
} from '@/lib/post-login-redirect'

export const loginLinkSearchSchema = z.object({
  signed_out: z.literal('1').optional(),
  error: z.string().optional(),
  next: z.string().optional(),
  return_app: z.enum(['suporte', 'admindesk']).optional(),
})

export type LoginLinkSearch = z.infer<typeof loginLinkSearchSchema>

export function normalizeLoginLinkToken(token: string): string | undefined {
  const trimmed = token.trim()
  if (trimmed.length === 0) return undefined
  const unquoted = trimmed.replace(/^['"]+|['"]+$/g, '')
  return unquoted.length > 0 ? unquoted : undefined
}

export function preservedLoginSearch(
  search: LoginLinkSearch,
): Record<string, string> {
  const out: Record<string, string> = {}
  if (search.return_app === 'suporte') {
    out.return_app = 'suporte'
    const sn = sanitizeSuporteHandoffNext(search.next)
    if (sn) out.next = sn
  } else if (search.return_app === 'admindesk') {
    out.return_app = 'admindesk'
    const an = sanitizeAdmindeskHandoffNext(search.next)
    if (an) out.next = an
  } else {
    const next = sanitizeHandoffNext(search.next)
    if (next) out.next = next
  }
  return out
}

export function buildLoginLinkHrefWithoutSignedOut(
  token: string,
  search: LoginLinkSearch,
  origin = 'http://localhost:3010',
): string {
  const { signed_out: _omit, ...rest } = search
  const u = new URL(`/l/${token}`, origin)
  for (const [k, v] of Object.entries(rest)) {
    if (v === undefined || v === null) continue
    if (typeof v === 'string' && v.length === 0) continue
    u.searchParams.set(k, String(v))
  }
  return u.toString()
}
